import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { PageHero } from "../components/pages/Blocks";
import { Reveal } from "../components/landing/Reveal";
import { GALLERY } from "../content/pages";

export default function Gallery() {
  const [idx, setIdx] = useState(null);
  const n = GALLERY.length;

  useEffect(() => {
    document.title = "Gallery | Wings of Fire Foundation";
  }, []);

  useEffect(() => {
    if (idx === null) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setIdx(null);
      if (e.key === "ArrowRight") setIdx((i) => (i + 1) % n);
      if (e.key === "ArrowLeft") setIdx((i) => (i - 1 + n) % n);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [idx, n]);

  return (
    <div data-testid="page-gallery">
      <PageHero eyebrow="Gallery" title="Moments of change" intro="Scholarship ceremonies, awareness programs, relief drives and community gatherings from across Telangana." image="/images/p12.jpg" />
      <section className="bg-[#FAF7F2] pb-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {GALLERY.map((g, i) => (
            <Reveal key={g} delay={(i % 3) * 0.06} className="mb-5 break-inside-avoid">
              <button data-testid={`gallery-item-${i}`} onClick={() => setIdx(i)} className="group block w-full overflow-hidden rounded-[24px]">
                <img src={`/images/${g}.jpg`} alt={`Wings of Fire Foundation moment ${i + 1}`} loading="lazy" className="w-full h-auto group-hover:scale-105 transition-transform duration-700" />
              </button>
            </Reveal>
          ))}
        </div>
      </section>
      <AnimatePresence>
        {idx !== null && (
          <motion.div data-testid="gallery-lightbox" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[60] bg-[#0F1D2F]/95 flex items-center justify-center p-4" onClick={() => setIdx(null)}>
            <img src={`/images/${GALLERY[idx]}.jpg`} alt="" className="max-h-[85vh] max-w-full rounded-2xl object-contain" onClick={(e) => e.stopPropagation()} />
            <button data-testid="lightbox-close" onClick={() => setIdx(null)} className="absolute top-5 right-5 w-12 h-12 rounded-full bg-white/10 text-white flex items-center justify-center" aria-label="Close"><X /></button>
            <button data-testid="lightbox-prev" onClick={(e) => { e.stopPropagation(); setIdx((idx - 1 + n) % n); }} className="absolute left-3 sm:left-6 w-12 h-12 rounded-full bg-white/10 text-white flex items-center justify-center" aria-label="Previous"><ChevronLeft /></button>
            <button data-testid="lightbox-next" onClick={(e) => { e.stopPropagation(); setIdx((idx + 1) % n); }} className="absolute right-3 sm:right-6 w-12 h-12 rounded-full bg-white/10 text-white flex items-center justify-center" aria-label="Next"><ChevronRight /></button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
